/**
 * The hidden-file-input pattern, once: renders children with an `open`
 * callback and forwards the chosen file. The input value is reset after
 * each pick so choosing the same file twice still fires.
 */
import { useRef, type ReactNode } from "react";
import { XLSX_ACCEPT } from "../../lib/config";

export function FilePicker({
  onFile,
  accept = XLSX_ACCEPT,
  children,
}: {
  onFile: (file: File) => void;
  accept?: string;
  children: (open: () => void) => ReactNode;
}) {
  const inputRef = useRef<HTMLInputElement>(null);
  return (
    <>
      {children(() => inputRef.current?.click())}
      <input
        ref={inputRef}
        type="file"
        accept={accept}
        style={{ display: "none" }}
        tabIndex={-1}
        aria-hidden="true"
        onChange={(e) => {
          const file = e.target.files?.[0];
          if (file) onFile(file);
          e.target.value = "";
        }}
      />
    </>
  );
}
